export default __webpack_public_path__ + "static/media/old1.d6b127f1.svg";